// extracted by mini-css-extract-plugin
module.exports = {"table":"TasksTable_table__37cW9"};